import { render, staticRenderFns } from "./BannerManagement.vue?vue&type=template&id=3391e96f&scoped=true"
import script from "./BannerManagement.vue?vue&type=script&lang=js"
export * from "./BannerManagement.vue?vue&type=script&lang=js"
import style0 from "./BannerManagement.vue?vue&type=style&index=0&id=3391e96f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391e96f",
  null
  
)

export default component.exports